// AI-CONTEXT: See docs/features/participation-ladder.md
import ladderSteps from './ladderSteps'

const num = (value) => (Number.isFinite(value) ? value : 0)

// Per-component difference between two computed states (T1 minus T0), plus the
// three aggregate impact figures (societal / government / participant).
//
// `incomePerson` is the productivity value (gross income x employability).
// `benefitCost` and `publicCost` are negative, so their T1-T0 delta is positive
// when the cost shrinks — i.e. a saving.
const calculateParticipationDelta = (t0 = {}, t1 = {}) => {
    const incomePerson = num(t1.incomePerson) - num(t0.incomePerson)
    const incomeTax = num(t1.incomeTax) - num(t0.incomeTax)
    const benefitCost = num(t1.benefitCost) - num(t0.benefitCost)
    const publicCost = num(t1.publicCost) - num(t0.publicCost)
    const volunteerValue = num(t1.volunteerValue) - num(t0.volunteerValue)

    const benefitSavings = benefitCost
    const publicCostSavings = publicCost

    return {
        incomePerson,
        incomeTax,
        benefitCost,
        publicCost,
        volunteerValue,
        ladderStepChange: ladderSteps(t0.ladderStep, t1.ladderStep).change,

        // Aggregates — personal income (bruto/netto) is deliberately NOT part of
        // the societal total; productivity captures the value created instead.
        totalSocietalValue: incomePerson + volunteerValue + benefitSavings + publicCostSavings,
        governmentBalance: incomeTax + benefitSavings + publicCostSavings,
        personalIncomeChange: incomePerson - incomeTax,
    }
}

export default calculateParticipationDelta
